import { configureStore } from "@reduxjs/toolkit";
import { authReducers } from "./slices/authSlice";
import configureSagaMiddleware from "redux-saga";
import rootSaga from "./saga";
import { passengerReducers } from "./slices/passengerSlice";
import { destinationReducers } from "./slices/destinationSlice";
import { routeReducers } from "./slices/routeSlice";
import { routeGroupReducers } from "./slices/routeGroupSlice";
import { connectionReducers } from "./slices/connectionSlice";

const saga = configureSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducers,
    passenger: passengerReducers,
    destination: destinationReducers,
    route: routeReducers,
    routeGroup: routeGroupReducers,
    connection: connectionReducers,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(saga),
});

saga.run(rootSaga);
